package com.tovtalk.data.remote.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class PostCreateRequest(
    @SerialName("post_type") val postType: String = "reel",
    @SerialName("caption") val caption: String? = null,
    @SerialName("hashtags") val hashtags: List<String> = emptyList(),
    @SerialName("sound_id") val soundId: Int? = null,
    @SerialName("video_path") val videoPath: String? = null,
    @SerialName("is_permanent") val isPermanent: Boolean = true,
    @SerialName("content_source") val contentSource: String? = null
)

@Serializable
data class ReportReasonDto(
    @SerialName("id") val id: Int,
    @SerialName("title") val title: String? = null,
    @SerialName("title_he") val titleHe: String? = null,
    @SerialName("title_en") val titleEn: String? = null,
    @SerialName("applies_to") val appliesTo: String? = null
)

@Serializable
data class ReportReasonsData(
    @SerialName("items") val items: List<ReportReasonDto>? = null
)

@Serializable
data class ReportReasonsResponse(
    @SerialName("data") val data: ReportReasonsData? = null,
    @SerialName("errors") val errors: String? = null
)

@Serializable
data class ReportPostRequest(
    @SerialName("post_id") val postId: Int,
    @SerialName("reason_id") val reasonId: Int,
    @SerialName("details") val details: String? = null
)

@Serializable
data class ReportUserRequest(
    @SerialName("user_id") val userId: Int,
    @SerialName("reason_id") val reasonId: Int,
    @SerialName("details") val details: String? = null
)

@Serializable
data class MusicDto(
    @SerialName("id") val id: Int,
    @SerialName("title") val title: String,
    @SerialName("artist") val artist: String,
    @SerialName("audio_url") val audioUrl: String,
    @SerialName("thumbnail") val thumbnail: String? = null,
    @SerialName("duration") val duration: Int,
    @SerialName("category_id") val categoryId: Int? = null
)
